import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Info, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const AboutSection = () => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // Fondu d'apparition au scroll (IntersectionObserver, déclenché une fois)
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const goToContact = () => {
    navigate('/contact');
    window.scrollTo(0, 0);
  };

  return (
    <section id="about" ref={sectionRef} className={`py-16 lg:py-24 bg-white reveal ${visible ? 'visible' : ''}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src="/images/about-technician.jpg"
                alt="Technicien informatique au travail"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Right - Content */}
          <div className="space-y-6">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-medium">
              <Info className="w-4 h-4" />
              <span>À propos de nous</span>
            </div>

            {/* Title */}
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
              Votre partenaire informatique de confiance
            </h2>

            {/* Description */}
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                Jeune auto-entrepreneur passionné par les technologies, je mets mon expertise au service des professionnels et des particuliers pour tous leurs besoins en installation et support informatique.
              </p>
              <p>
                Mon objectif est de vous offrir des solutions techniques fiables, rapides et adaptées à vos besoins spécifiques, tout en garantissant un service personnalisé et réactif.
              </p>
            </div>

            {/* Stats */}
            <div className="flex gap-6 pt-4">
              <div className="bg-gray-50 rounded-xl px-6 py-4 border border-gray-100">
                <p className="text-3xl lg:text-4xl font-bold text-blue-500">100%</p>
                <p className="text-gray-600 text-sm">Satisfaction client</p>
              </div>
              <div className="bg-gray-50 rounded-xl px-6 py-4 border border-gray-100">
                <p className="text-3xl lg:text-4xl font-bold text-blue-500">6j/7</p>
                <p className="text-gray-600 text-sm">Support disponible</p>
              </div>
            </div>

            {/* CTA Button */}
            <Button 
              className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg flex items-center gap-2 h-auto transition-all duration-200 mt-6"
              onClick={goToContact}
            >
              Contactez-nous
              <ArrowRight className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
